import { ASYNC_OPERATIONS_PATH } from 'installations/navigation';

const indexComponent = require('./routes/index/components/InstallationAsyncOperationsList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: ASYNC_OPERATIONS_PATH,
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationAsyncOperations'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/asyncOperations/index.js